module.exports = __webpack_public_path__ + "img/a8_07.0896e28d.jpg";